var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
const ToggleButton = (_a) => {
    var { children, onClick, onToggle, pressed } = _a, props = __rest(_a, ["children", "onClick", "onToggle", "pressed"]);
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
        if (onToggle && !e.defaultPrevented)
            onToggle(!pressed);
    };
    return (React.createElement(Button, Object.assign({ onClick: handleClick, type: pressed ? "default" : "secondary", "aria-pressed": pressed }, props), children));
};
ToggleButton.defaultProps = {
    children: null,
    className: "",
    disabled: false,
    icon: null,
    loading: false,
    onToggle: null,
    pressed: false,
    size: "small",
};
ToggleButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    loading: PropTypes.bool,
    noHover: PropTypes.bool,
    noPadding: PropTypes.bool,
    onToggle: PropTypes.func,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(["large", "small"]),
};
export default ToggleButton;
export { ToggleButton };
//# sourceMappingURL=index.js.map